module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Flawil-7faa07f430bd9c1742b334f0d9b96c7e.svg";